import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DateTime } from 'luxon';
import { NGXLogger } from 'ngx-logger';
import { lastValueFrom } from 'rxjs';
import { PopFeatureFlag } from './models/pop-feature-flag.model';
import { PopFeatureFlagsDto } from './models/pop-feature-flags.dto';
import { PopSettingsDto } from './models/pop-settings.dto';

@Injectable({
  providedIn: 'root'
})
export class PopSettingService {
  private settings: Promise<PopSettingsDto>;

  public constructor(private http: HttpClient, private logger: NGXLogger) {}

  private async getSettingsInternal() {
    const noCache = DateTime.now().valueOf(); // always get a new version
    const settings = lastValueFrom(this.http.get<PopSettingsDto>(`/assets/pop-settings.json?t=${noCache}`));

    return settings;
  }

  public getSettings(): Promise<PopSettingsDto> {
    if (!this.settings) {
      this.settings = this.getSettingsInternal();
    }

    return this.settings;
  }

  public async getFeatureFlags(): Promise<PopFeatureFlag[]> {
    const settings = await this.settings;
    const flags = Object.keys(settings.features ?? {}).map(k => {
      const key = k as keyof PopFeatureFlagsDto;
      const value = settings?.features[key];

      const flag = new PopFeatureFlag(key, value);
      return flag;
    });

    return flags;
  }

  public async getFeatureFlagValue(key: keyof PopFeatureFlagsDto) {
    const flags = await this.getFeatureFlags();

    return flags.find(f => f.key === key)?.value;
  }
}
